import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { orderBy as sort } from "lodash";

import { RubbleTicket } from "../interface/api/RubbleTicket";
import { RubbleTicketState } from "../interface/redux-types/RubbleTicketState";
import { RootState } from "..";

const initialState: RubbleTicketState = {
  tickets: [],
  ticket: null,
};

const slice = createSlice({
  name: "rubbleTicket",
  initialState,
  reducers: {
    setRubbleTickets: (
      state,
      action: PayloadAction<{ tickets: RubbleTicket[] }>
    ) => {
      state.tickets = action.payload.tickets;
    },
    setRubbleTicket: (
      state,
      action: PayloadAction<{ ticket: RubbleTicket | null }>
    ) => {
      state.ticket = action.payload.ticket;
    },
    updateRubbleTicketInList: (
      state,
      action: PayloadAction<{ ticket: RubbleTicket }>
    ) => {
      const { ticket } = action.payload;
      const index = state.tickets.findIndex((t) => t.id === ticket.id);
      if (index >= 0) {
        state.tickets[index] = ticket;
      }
    },
  },
});

export const {
  setRubbleTickets,
  setRubbleTicket,
  updateRubbleTicketInList,
} = slice.actions;

export const getRubbleTickets = createSelector(
  (state: RootState) => state.rubbleTicketStore?.tickets ?? [],
  (tickets) => sort(tickets, ["ticketNumber"], ["desc"])
);

export const getRubbleTicket = createSelector(
  (state: RootState) => state.rubbleTicketStore?.ticket ?? null,
  (ticket) => ticket
);

export const reducer = slice.reducer;
